import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ConfigCI/services/constants";

export const getTestCaseReport = createAction(`${moduleSlug}/GET_TEST_CASE_REPORT`);
export const setTestCaseReportDialog = createAction(`${moduleSlug}/SET_TEST_CASE_REPORT_DIALOG`);
export const mergeTestCaseReportDialog = createAction(`${moduleSlug}/MERGE_TEST_CASE_REPORT_DIALOG`);
export const restartTestCase = createAction(`${moduleSlug}/RESTART_TEST_CASE`);
